import { useApprovals } from './live.ts';
import { AskCard } from './AskAnswer.tsx';
import { isAnswerable, recentlyAnswered } from './askModel.ts';
import { RequestCard } from './RequestCard.tsx';
import { useNow } from '@orgus/ui';

/**
 * Pending requests for the given sessions, answered in place with the shared answer (ADR 0072):
 * tool requests on the request card (Allow once, Allow for session with its pattern, Make it a
 * rule, Deny with a note, the high-risk confirm), questions, plans and MCP forms on the question
 * card, which stays a few minutes as "You answered: ..." (R-HL-6). Renders nothing when none.
 */
export function SessionApprovals({ sessionIds }: { sessionIds: readonly string[] }) {
  const { approvals } = useApprovals();
  const now = useNow(30_000);
  const pending = (approvals?.pending ?? []).filter((a) => a.state === 'pending' && sessionIds.includes(a.sessionId));
  // Kept in place after answering, so the card collapses instead of vanishing.
  const answered = recentlyAnswered(approvals?.recent ?? [], now, sessionIds).filter((a) => !pending.some((p) => p.id === a.id));
  const cards = [...pending, ...answered].sort((x, y) => x.createdAt - y.createdAt);
  if (!cards.length) return null;
  return (
    <div className="flex flex-col gap-2">
      {cards.map((a) => (isAnswerable(a) ? <AskCard key={a.id} a={a} surface="drawer" /> : a.state === 'pending' ? <RequestCard key={a.id} a={a} showSession={sessionIds.length > 1} /> : null))}
    </div>
  );
}
